import { useEffect, useState } from "react";
import { ClientDetails } from "src/interfaces/IClient";
import useAlenProperties from "src/services/alen/useAlenProperties";
import { makeUseQuery } from "src/services/graphql/utils";
import { queryGetProperties } from "src/services/graphql/Property";
import { mergeAlenProperties } from "src/services/alen/utils";
import { Property } from "src/interfaces/IProperty";

const usePropertyQuery = makeUseQuery(
  queryGetProperties,
  (dbname) => `${dbname}_property`
);

export default function useCombinedProperty({
  client,
}: {
  client: ClientDetails;
}) {
  const [combinedProperty, setCombinedProperty] = useState<
    Property[] | undefined
  >();
  const wyndProperties = usePropertyQuery<Property[]>(client.client_dbname, {
    variables: {},
  });
  const alenProperties = useAlenProperties();
  const alenData = alenProperties.data;

  useEffect(() => {
    if (wyndProperties.isLoading || alenProperties.isLoading) {
      return;
    }
    if (!wyndProperties.data) return;
    if (!alenProperties.data) return;
    const mergedData = mergeAlenProperties(
      wyndProperties.data,
      alenProperties.data
    );
    setCombinedProperty(mergedData);
  }, [
    wyndProperties.data,
    alenData,
    wyndProperties.isLoading,
    alenProperties.isLoading,
    alenProperties.data,
  ]);

  return {
    data: combinedProperty,
    loading: wyndProperties.isLoading || alenProperties.isLoading,
    error: wyndProperties.error || alenProperties.error,
  };
}
